<script setup lang="ts">
import {RcsSuggestion} from "@/notification-template/interfaces";

defineProps<{
    payload: RcsSuggestion
}>();
</script>

<template>
  <button class="border-[1.5px] bg-gray-100 px-2 py-1 rounded-lg text-xs font-medium">
    {{ payload.text }}
  </button>
</template>

<style scoped>

</style>
